// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"8ee19050","453":"d855a71b","466":"f8d7e557","501":"6e42ffeb"}[chunkId] + ".chunk.js";
};